import { z } from 'zod';

export const insurancePolicySchema = z.object({
  policy_type: z.enum(['health', 'life', 'auto', 'home', 'travel', 'disability', 'other'], {
    errorMap: () => ({ message: 'Please select a valid policy type' }),
  }),
  provider_name: z.string().min(1, 'Provider name is required'),
  policy_number: z.string().min(1, 'Policy number is required'),
  coverage_amount: z.number({
    required_error: 'Coverage amount is required',
    invalid_type_error: 'Coverage amount must be a number',
  }).positive('Coverage amount must be positive'),
  premium_amount: z.number({
    required_error: 'Premium amount is required',
    invalid_type_error: 'Premium amount must be a number',
  }).positive('Premium amount must be positive'),
  premium_frequency: z.enum(['monthly', 'quarterly', 'semi_annual', 'annual'], {
    errorMap: () => ({ message: 'Please select a valid premium frequency' }),
  }),
  currency: z.string().length(3, 'Currency must be 3 characters (e.g., USD, EUR, GBP)'),
  start_date: z.string().refine(
    (val) => !isNaN(Date.parse(val)),
    { message: 'Invalid start date' }
  ),
  end_date: z.string().refine(
    (val) => !isNaN(Date.parse(val)),
    { message: 'Invalid end date' }
  ),
  deductible_amount: z.number().positive('Deductible amount must be positive').optional(),
  beneficiary_name: z.string().optional(),
  beneficiary_relationship: z.string().optional(),
  provider_contact: z.string().optional(),
  notes: z.string().optional(),
}).refine(
  (data) => new Date(data.end_date) > new Date(data.start_date),
  {
    message: 'End date must be after start date',
    path: ['end_date'],
  }
);

export type InsurancePolicyFormData = z.infer<typeof insurancePolicySchema>;
